import { h, render } from 'preact';
import './style/index.css';
import MultiPageForm from './client_forms/MultiPageForm.jsx';

const App = () => (
  <main>
    <div className="container">
      <MultiPageForm />
    </div>
  </main>
);

render(<App />, document.body);